import { Position, Toaster } from "@blueprintjs/core";

// separate toaster so we can position better relative to editing interface

export default Toaster.create({position: Position.BOTTOM});



// WEBPACK FOOTER //
// ./src/core/components/editor/EditorToaster.ts